import { Link } from "react-router-dom";
import { getAvatarUrl } from "../config/users";
import { UserAuth } from "../context/AuthContext";

const Navbar = () => {
  const { user, logOut } = UserAuth();

  const handleSignOut = async () => {
    try {
      await logOut();
    } catch (error) {
      console.error("Sign out error:", error);
    }
  };

  const avatarUrl = getAvatarUrl(user?.email, user?.photoURL) || "/default-avatar.jpg";

  return (
    <div className="container mx-auto text-center p-5">
      <div className="flex justify-between w-full">
        <Link to={`/`}>
          <img src="/logo.svg" alt="Monika Logo" className="mx-auto w-48 h-auto -ml-1" />
        </Link>
        {user?.displayName && (
          <div className="flex items-center">
            <img
              src={avatarUrl}
              alt="Avatar"
              className="w-10 h-10 rounded-full mr-2 cursor-pointer hover:ring-2 hover:ring-primary/30 transition-all"
              onClick={handleSignOut}
              title="Sign out"
              referrerPolicy="no-referrer"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
